import ROUTES from '@constants/routes';

export const DASHBOARD_ITEMS = [
  {
    title: 'Dashboard',
    key: 'dashboard',
    href: ROUTES.ROOT,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
    style: { marginBottom: 20 },
    end: true,
  },
];

const pages = {
  title: 'Pages',
  key: 'pages',
  href: ROUTES.PAGES,
  color: 'wonderly-orange-light',
  activeColor: 'wonderly-orange',
};

const articles = {
  title: 'Articles',
  key: 'articles',
  href: ROUTES.ARTICLES,
  color: 'wonderly-blue-light',
  activeColor: 'wonderly-blue',
};

const emails = {
  title: 'Emails',
  key: 'emails',
  href: ROUTES.EMAILS,
  color: 'wonderly-purple-light',
  activeColor: 'wonderly-purple',
};

const media = {
  title: 'Media',
  key: 'media',
  href: ROUTES.MEDIA_LIBRARY,
  color: 'wonderly-green-light',
  activeColor: 'wonderly-green',
};
const athletes = {
  title: 'Athletes',
  key: 'athletes',
  href: ROUTES.ATHLETES,
  color: 'wonderly-white',
  activeColor: 'wonderly-silver',
};

const library = {
  title: 'Library',
  key: 'library',
  href: ROUTES.LIBRARY,
  color: 'wonderly-orange-light',
  activeColor: 'wonderly-orange',
};

const video = {
  title: 'Videos',
  key: 'videos',
  href: ROUTES.VIDEO,
  color: 'wonderly-green-light',
  activeColor: 'wonderly-green',
};

const menus = {
  title: 'Menus',
  key: 'menus',
  href: ROUTES.MENUS,
  color: 'wonderly-white',
  activeColor: 'wonderly-silver',
};

const sponsors = {
  title: 'Sponsors',
  key: 'sponsors',
  href: ROUTES.SPONSORS,
  color: 'wonderly-white',
  activeColor: 'wonderly-silver',
};

const languages = {
  title: 'Languages',
  key: 'languages',
  href: '/languages',
  color: 'wonderly-white',
  activeColor: 'wonderly-silver',
};

export const CONTENT_SUPER_ADMIN_ITEMS = [pages, articles, emails, media, library, video, athletes];

export const CONTENT_LOC_ADMIN_ITEMS = [pages, articles, emails, media, athletes];

export const SETUP_SUPER_ADMIN_ITEMS = [
  {
    title: 'Competitions',
    key: 'competitions',
    href: ROUTES.COMPETITIONS,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
  {
    title: 'Campaigns',
    key: 'campaigns',
    href: ROUTES.CAMPAIGNS,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
  {
    title: 'Events',
    key: 'events',
    href: ROUTES.EVENTS,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
  menus,
  {
    title: 'Appearance',
    key: 'appearance',
    href: ROUTES.APPEARANCE,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
  {
    title: 'Minisites',
    key: 'minisites',
    href: ROUTES.MINISITES,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
  {
    title: 'Locations',
    key: 'locations',
    href: ROUTES.LOCATIONS,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
  sponsors,
  languages,
  {
    title: 'Where to watch',
    key: 'where-to-watch',
    href: ROUTES.WHERE_TO_WATCH,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
];

export const SETUP_LOC_ADMIN_ITEMS = [
  menus,
  {
    title: 'Event Appearance',
    key: 'event-appearance',
    href: ROUTES.EVENT_APPEARANCE,
    tooltip: 'Event Appearance',
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
  sponsors,
  languages,
];

export const BOOK_OF_RULES_ITEMS = [
  {
    title: 'Books',
    key: 'books',
    href: ROUTES.BOOKS,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
  {
    title: 'Chapters',
    key: 'chapters',
    href: ROUTES.CHAPTERS,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
  {
    title: 'Sections',
    key: 'sections',
    href: ROUTES.SECTIONS,
    color: 'wonderly-white',
    activeColor: 'wonderly-silver',
  },
];
